import { create } from 'zustand';
import { api } from './api';

export interface Job {
  id: string;
  job_number?: string;
  title: string;
  type: string;
  client_id?: string;
  client_name?: string;
  client_address?: string;
  client_xero_customer_id?: string;
  client_email?: string;
  location?: { address?: string; latitude?: number; longitude?: number };
  date: string;
  time?: string;
  duration_type: string;
  duration_days?: number;
  duration_hours?: number;
  assigned_to: string;
  status: string;
  notes?: string;
  invoice_number?: string;
  hours_to_invoice?: number;
  consumables?: any[];
  comments?: any[];
  service_report?: any; // legacy
  service_reports?: any[];
  parts_last_received_at?: string;
  created_at: string;
  updated_at: string;
}

interface JobStore {
  jobs: Job[];
  loading: boolean;
  fetchJobs: (status?: string, type?: string) => Promise<void>;
  updateJob: (id: string, updates: Partial<Job>) => Promise<Job | null>;
  deleteJob: (id: string) => Promise<boolean>;
}

export const useJobStore = create<JobStore>((set) => ({
  jobs: [],
  loading: false,

  fetchJobs: async (status, type) => {
    set({ loading: true });
    try {
      const params: any = {};
      if (status && status !== 'All') params.status = status;
      if (type && type !== 'All') params.type = type;
      const res = await api.get('/jobs', { params });
      set({ jobs: res.data, loading: false });
    } catch (e) {
      set({ loading: false });
    }
  },

  updateJob: async (id, updates) => {
    try {
      const res = await api.put(`/jobs/${id}`, updates);
      set((s) => ({
        jobs: s.jobs.map((j) => (j.id === id ? res.data : j)),
      }));
      return res.data;
    } catch (e) {
      return null;
    }
  },

  deleteJob: async (id) => {
    try {
      await api.delete(`/jobs/${id}`);
      set((s) => ({ jobs: s.jobs.filter((j) => j.id !== id) }));
      return true;
    } catch (e) {
      return false;
    }
  },
}));

export interface Client {
  id: string;
  name: string;
  addresses: { address_line: string; latitude?: number; longitude?: number }[];
  email?: string | null;
  phone?: string | null;
  xero_customer_id?: string | null;
  created_at: string;
}

interface ClientStore {
  clients: Client[];
  loading: boolean;
  fetchClients: () => Promise<void>;
}

export const useClientStore = create<ClientStore>((set) => ({
  clients: [],
  loading: false,
  fetchClients: async () => {
    set({ loading: true });
    try {
      const res = await api.get('/clients');
      set({ clients: res.data, loading: false });
    } catch (e) {
      set({ loading: false });
    }
  },
}));
